import { render } from "./AdminSignupsDashboard.vue?vue&type=template&id=389d42ec&scoped=true"
import script from "./AdminSignupsDashboard.vue?vue&type=script&lang=js"
export * from "./AdminSignupsDashboard.vue?vue&type=script&lang=js"

import "./AdminSignupsDashboard.vue?vue&type=style&index=0&id=389d42ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389d42ec"]])

export default __exports__